import React from "react";
import Footer from "./footer";
import { Box } from "@mui/material";
import Header from "./header";

function Contact() {
  return (
    <>
      <Header />
      <div>
        <div className="rbt-conatct-area bg-gradient-11 rbt-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center mb--60">
                  <span className="subtitle bg-secondary-opacity">
                    Contact Us
                  </span>
                  <h2 className="title">
                    {" "}
                    Contact with AISECT Inter College <br /> can join with us.
                  </h2>
                </div>
              </div>
            </div>
            <div className="row g-5">
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate"
                data-sal="slide-up"
                data-sal-delay={150}
                data-sal-duration={800}
              >
                <div className="rbt-address">
                  <div className="icon">
                    <i className="feather-headphones" />
                  </div>
                  <div className="inner">
                    <h4 className="title">Contact Phone Number</h4>
                    <p>
                      <a href="tel:+917479708899">(+91) 7479708899</a>
                    </p>
                    <p>
                      <a href="tel:+918002748899">(+91) 8002748899</a>
                    </p>
                    {/* <p>
                      <a href="tel:+222222222333">+91 8965656513</a>
                    </p> */}
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate"
                // data-sal="slide-up"
                // data-sal-delay={200}
                // data-sal-duration={800}
              >
                <div className="rbt-address">
                  <div className="icon">
                    <i className="feather-mail" />
                  </div>
                  <div className="inner">
                    <h4 className="title">Our Email Address</h4>
                    <p>
                      <a href="mailto:aisectintercollege2023@gmail.com">aisectintercollege2023@gmail.com</a>
                    </p>
                    {/* <p>
                      <a href="mailto:example@gmail.com">example@gmail.com</a>
                    </p> */}
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate"
                // data-sal="slide-up"
                // data-sal-delay={250}
                // data-sal-duration={800}
              >
                <div className="rbt-address">
                  <div className="icon">
                    <i className="feather-map-pin" />
                  </div>
                  <div className="inner">
                    <h4 className="title">Our Location</h4>
                    <p>
                      Main Campus : Vill: Jonhiya, (Tarba-Kharba), P.O. :
                      Maheshra,P.S. : Daru, Dist. : Hazaribagh, Jharkhand -
                      825313
                      <br />
                      City Campus : AISECT University,Matwari Chowk, Hazaribagh,
                      Jharkhand - 825301
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-contact-address">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-6">
                <div className="thumbnail">
                  <img
                    className="w-100 radius-6"
                    src="assets/images/about/contact.jpg"
                    alt="Contact Images"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                  <div className="section-title text-start">
                    <span className="subtitle bg-primary-opacity">
                      EDUCATION FOR EVERYONE
                    </span>
                  </div>
                  <h3 className="title">
                    For Course Enquiry You Can Contact With Me
                  </h3>
                  <form
                    id="contact-form"
                    method="POST"
                    // action="https://rainbowit.net/html/histudy/mail.php"
                    className="rainbow-dynamic-form max-width-auto"
                  >
                    <div className="form-group">
                      <input
                        name="contact-name"
                        id="contact-name"
                        type="text"
                      />
                      <label>Name</label>
                      <span className="focus-border" />
                    </div>
                    <div className="form-group">
                      <input name="contact-phone" type="email" />
                      <label>Email</label>
                      <span className="focus-border" />
                    </div>
                    <div className="form-group">
                      <input type="text" id="subject" name="subject" />
                      <label>Your Subject</label>
                      <span className="focus-border" />
                    </div>
                    <div className="form-group">
                      <textarea
                        name="contact-message"
                        id="contact-message"
                        defaultValue={""}
                      />
                      <label>Message</label>
                      <span className="focus-border" />
                    </div>
                    <div className="form-submit-group">
                      <button
                        name="submit"
                        type="submit"
                        id="submit"
                        className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                      >
                        <span className="icon-reverse-wrapper">
                          <span className="btn-text">GET IT NOW</span>
                          <span className="btn-icon">
                            <i className="feather-arrow-right" />
                          </span>
                          <span className="btn-icon">
                            <i className="feather-arrow-right" />
                          </span>
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-google-map bg-color-white rbt-section-gapTop">
          <iframe
            className="w-100"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3644.303992834027!2d85.4860528!3d24.020343!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f48324063dff6f%3A0x243bb036cc4d7335!2sAISECT%20University!5e0!3m2!1sen!2sin!4v1678877048056!5m2!1sen!2sin"
            height={600}
            style={{ border: 0 }}
          />
        </div>

        <Box sx={{ pb: "30px" }}></Box>
        <Footer />
      </div>
    </>
  );
}

export default Contact;
